import { useSelector } from "react-redux";
import { selectOnboardingActive } from "../../store/slices/uiSlice";
import AppointmentModal from "./AppointmentModal";
import AppointmentWizardModal from "./appointmentWizard/AppointmentWizardModal";

/**
 * Routes between the appointment wizard (create + edit, all clinics) and the
 * classic AppointmentModal. Same prop contract as AppointmentModal — call
 * sites only change the import.
 *
 * The classic modal remains only for the guided onboarding tour, which is
 * anchored to its DOM.
 */
function AppointmentEntryModal(props) {
  const isOnboardingActive = useSelector(selectOnboardingActive);

  // Blocked-time entries always open in the wizard — the classic modal
  // knows nothing about blocks.
  if (props.appointment?.isBlockedTime === true) {
    return <AppointmentWizardModal {...props} />;
  }

  return isOnboardingActive ? (
    <AppointmentModal {...props} />
  ) : (
    <AppointmentWizardModal {...props} />
  );
}

export default AppointmentEntryModal;
